// extracted by mini-css-extract-plugin
export default {"pointerWrapper":"pointerWrapper---UoDg9"};